<template>
<v-dialog
    v-model="dialog"
    max-width="920"
>

<v-overlay
    
    opacity="0.3"
    :value="show_upload"
    z-index="10"
>
     <v-progress-circular
      :size="70"
      :width="7"
      :value="spinner_value"
      color="primary"
      :indeterminate="spinner_indeterminate"
    >
    </v-progress-circular>
</v-overlay>

    <v-card>
    <v-card-title class="headline">{{title}}</v-card-title>

    <v-card-text>
        <div
            style="text-align:center; margin-top: 15px; margin-bottom: 15px;"
            v-if="winepulse"
        >
            <img src="@/assets/winepulse-logo.png" width="200px" style="max-width: 90%"/>

            <div
                style="margin-top: 15px"
            >
                <a 
                    href="https://redchirp.com/how-to-access-redchirp-reports-from-winepulse/" 
                    target="_blank"
                >
                    How to access RedChirp reports from WinePulse
                </a>
            </div>
        </div>

        <div
            v-if="dialog_hint != null"
            style="margin-bottom: 15px; margin-top: 7px"
            v-html="dialog_hint"
        />
        
       <v-sheet
            tabindex="0"
            
            style="border: 1px solid rgba(0,0,0,0.25); text-align: center; margin-bottom: 10px; position: relative;"
            width="100%"
            height="220"
            class="pa-2"
            ref="dropzone"
            v-cloak 
            @drop.prevent="addDropFile" 
            @dragover.prevent
            v-if="no_files"
        >
        
            <div style="position: absolute; margin: 0; top: 50%; transform: translateY(-50%); text-align: center; width: 100%">
                <div v-on:click="showFileOpenDialog()">
                    <v-icon x-large>mdi-cloud-upload-outline</v-icon><br/>
                    Drop your file(s) here, or click for a file selection dialog
                </div>

                <div
                    style="margin-top: 25px"
                    v-if="allow_media_assets"
                >
                    <v-btn
                        style="height: 55px; width: 200px; margin-right: 15px;"
                        v-if="show_outshinery"
                        v-on:click="onClickMediaAssetPicker('outshinery')"
                    >
                        <img src="@/assets/outshinery-logo.png" height="42"/>
                    </v-btn>

                   
                </div>
            </div>
        
        </v-sheet>

        <div
            @drop.prevent="addDropFile" 
            @dragover.prevent
            v-if="!no_files"
            style="min-height: 220px"
        >
            <v-list>
                <v-list-item
                    v-for="(item, index) in blob_meta_data"
                    :key="index"
                >
                    <v-list-item-avatar v-if="item.isProcessingPending()"> 
                        <v-progress-circular
                            :size="25"
                            :width="3"
                            color="primary"
                            indeterminate
                        />
                    </v-list-item-avatar>

                    <v-list-item-avatar v-if="!item.isImage() && item.isProcessingComplete()"> 
                        <v-icon size="35" style="padding: 0">{{item.getFileIcon()}}</v-icon>
                    </v-list-item-avatar>

                    <v-list-item-avatar v-if="item.isImage() && item.isProcessingComplete()">
                        <v-img :src="getBlobSrcURL(item)"></v-img>
                    </v-list-item-avatar>

                    <v-list-item-content>
                    <v-list-item-title v-text="getLabel(item)"></v-list-item-title>
                    </v-list-item-content>

                    <v-list-item-action>
                        <v-menu 
                            bottom 
                            offset-y  
                        >

                        <template v-slot:activator="{ on }">
                            
                            <v-icon 
                                size="25"
                                v-on="on"
                            >
                                mdi-dots-vertical
                            </v-icon>
                            
                        </template>

                        <v-list>
                            <v-list-item
                            v-for="(item, menu_item_index) in createMenuItems(index)"
                            :key="menu_item_index"
                            v-on:click="onClickMenuItem(index,item)"
                            :disabled="item.disabled"
                            >
                            <v-list-item-title>{{ item.text }}</v-list-item-title>
                            </v-list-item>
                        </v-list>

                    </v-menu> 

                    </v-list-item-action>

                </v-list-item>
            </v-list>

        </div>
        
        <v-checkbox
            label="Send images as links"
            v-if="process_media"
            value="send-images-as-links"
            v-model="options"
            v-show="show_send_as_links"
        >
             <v-icon 
                slot="append" 
                style="pointer-events: auto;"
                v-on:click="showHelpSendImagesAsLinks"
            >
                mdi-information-outline
            </v-icon>
        </v-checkbox>

        <v-select
            label="Recent Files"
            :items="recent_files"
            item-text="label"
            return-object
            v-on:input="afterSelectRecentFile"
            v-on:change="resetSelected"
            v-model="selected_recent_file"
        >
            <template v-slot:append-item>
                <v-divider class="mb-2"></v-divider>
                <v-list-item
                    v-on:click="openSearchAttachmentsDialog()"
                >
                    <v-list-item-content>
                        <v-list-item-title>
                            Search Attachments
                        </v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
            </template>
        </v-select>

        <m-text-field
            label="Message to send with your files (optional)"
            v-if="show_with_message"
            v-model="with_message"
            emoji
        />

        <m-select-vcard
            label="Attach contact card (optional)"
            v-model="vcard_id"
            v-if="show_with_vcard"
            ref="select-contact-card"
            :endpoint="for_endpoint"
        />

   
    </v-card-text>

    <v-card-actions>
        <v-btn
            color="primary"
            text
            v-on:click="showFileOpenDialog"
            v-if="allow_multiple"
        >
            Add File...
        </v-btn>

        <v-spacer></v-spacer>

        <v-btn
            color="gray darken-1"
            text
            @click="dialog = false"
        >
        Cancel
        </v-btn>

        <v-btn
            color="primary darken-1"
            text
            @click="onOk"
            :disabled="!valid"
        >
        Ok
        </v-btn>
    </v-card-actions>
    </v-card>

    <div
        v-show="false"
    >
        <input 
            type="file" 
            ref="input-file-upload" 
            :multiple="allow_multiple"
            :accept="this.accept"
            v-on:change="onFileControlChanged($event)"
        />
    </div>

    <m-search-previously-uploaded-attachments
        v-on:on-attach-files="afterSelectMultipleRecentFiles($event)"
        ref="search-attachments"
    />

    <m-media-asset-picker-dialog
        ref="media-asset-picker"
        v-on:select="onAddMediaAssets"
    />

    

</v-dialog>
</template>

<script>

const BlobMetaData = require('@/js/BlobMetaData.js');

export default {
    props: {

        title: {
            type: String,
            default: function() { return "Attach Files"; }
        },
        externally_visible: {
            type: Boolean,
            default: function () { return true; }
        },

        accept: {
            type: Array,
            default: function () { return null; }
        },

        allow_multiple: {
            type: Boolean,
            default: function () { return true; }
        },

        limit_to_size: {
            type: Number,
            default: function () { return -1; }
        },

        show_send_as_links: {
            type: Boolean,
            default: function() { return true; }
        },

        show_with_message: {
            type: Boolean,
            default: function() { return false; }
        },

        show_with_vcard: {
            type: Boolean,
            default: function() { return false; }
        },

        organization_id: {
            type: String,
            default: function() { return null; }
        },

         purpose: {
            Type: String,
            default: function() { return "attachment"; }
        },

        dialog_hint: {
            Type: String,
            default: function() { return null; }
        },

        winepulse: {
            Type: Boolean,
            default: function() { return false; }
        },

        allow_media_assets: {
            Type: Boolean,
            default: function() { return true; },
        },

        for_endpoint: {
            Type: String,
            default: function() { return null; },
        },
    },

    data() {
        return {
            dialog: false,
            valid: false,
            blob_meta_data: [],
            vcard_id: null,

            process_media: true,
            
            show_upload: false,
            spinner_indeterminate: true,
            spinner_value: 0,

            pending_upload_count: 0,

            options: [],
            recent_files: [],
            show_outshinery: false,
            with_message: null,
            selected_recent_file: null,
        }
    },

    created () {
        this.$event_bus.$on('update-blob-meta-data', this.updateBlobMetaData);
    },

    beforeDestroy () {
        this.$event_bus.$off('update-blob-meta-data',this.updateBlobMetaData);
    },

    methods: {
        resetSelected()
        {
            this.value = null;
        },

        afterSelectMultipleRecentFiles(files)
        {
            this.getBlobDataFromRedChirp(files);
        },

        openSearchAttachmentsDialog()
        {
            this.$refs['search-attachments'].showDialog();
        },

        onAddMediaAssets(assets)
        {
            let blob_ids = [];

            for ( let i = 0; i < assets.length; i++ )
            {
                if ( assets[i].image_url_blob_id == null )
                    continue;

                blob_ids.push(assets[i].image_url_blob_id);
            }

            this.getBlobDataFromRedChirp(blob_ids);
        },

        afterSelectRecentFile(file_selected)
        {
            if ( !this.isValidFileType(file_selected) )
            {
                return;
            }

            if ( !this.allow_multiple && this.blob_meta_data.length > 0 )
            {
                this.$rc.alert(
                    'Only One Attachment Allowed',
                    'Delete the previous attachment before adding another.'
                );
                return;
            }

            this.getBlobDataFromRedChirp(file_selected.blob_id);
        },

        isValidFileType(file_selected)
        {
            if ( this.accept == null || this.accept.length == 0 ) return true;

            let valid_file = false;

            for ( let i=0; i < this.accept.length; i++ )
            {
                if ( file_selected.content_type == this.accept[i] )
                {
                    valid_file = true;
                    break;
                }
            }

            if ( valid_file ) return true;

            this.$rc.alert(
                'Invalid File Type',
                'File type is not supported. Supported file types are: ' + this.accept
            );

            return false;
        },
        getBlobDataFromRedChirp(blob_ids, force_reset)
        {
            this.$rc.showSpinner();
            this.$rc.getBlobMetaDataMultiple(
                blob_ids,

                (data) => {
                    this.$rc.hideSpinner();

                    if (force_reset)
                    {
                        this.blob_meta_data = [];
                    }

                    for (let i = 0; i < data.meta_data.length; i++)
                    {
                        let blob_data = new BlobMetaData(data.meta_data[i]);

                        if ( !this.checkSizeLimit(blob_data) ) continue;

                        this.blob_meta_data.push(blob_data);
                    }

                    this.dialog = true;
                    this.validate();
                },

                () => {
                    this.$rc.hideSpinner();
                    this.$rc.alert('Error', 'Unable to get blob meta data');
                }
            );
        },

        showDialog(blob_ids, process_media, with_message, vcard_id)
        {
            this.selected_recent_file = null;
            this.options = [];
            this.blob_meta_data = [];
            this.valid = false;

            this.process_media = process_media;
            this.show_upload = false;
            this.pending_upload_count = 0;
            this.getBlobDataFromRedChirp(blob_ids);
            this.loadRecentFilesByEmployee();

            if ( with_message != null )
            {
                with_message = with_message.trim();
                if ( with_message.length == 0 )
                    with_message = null;
            }

            this.with_message = with_message;

            if (null != vcard_id)
            {
                vcard_id = vcard_id.trim();
                if (vcard_id.length == 0)
                {
                    vcard_id = null;
                }
            }

            this.vcard_id = vcard_id;

            this.validate();
        },

        updateBlobMetaData(signal)
        {
            let blob_id = signal.blob_id;

            this.$rc.getBlobMetaData(
                blob_id,

                (response_data) => {
                    let meta_data = new BlobMetaData(response_data.meta_data);

                    for ( let i = 0; i < this.blob_meta_data.length; i++ )
                    {
                        if ( this.blob_meta_data[i].getBlobId() == meta_data.getBlobId() )
                        {
                            if ( meta_data.isProcessingFailed() || !this.checkSizeLimit(meta_data) )
                                this.blob_meta_data.splice(i,1);
                            else
                             this.blob_meta_data[i] = meta_data;
                        }
                    }

                    this.validate();
                    this.$forceUpdate();

                    if ( meta_data.isProcessingFailed() )
                        alert('Processing of the file "'+meta_data.getLabel()+' failed.');
                },

                () => {
                    alert('Unable to optomize image.');
                }
            );
            
        },

        checkSizeLimit(meta_data)
        {
            if ( this.limit_to_size <= 0 || !meta_data || !meta_data.data ) return true;
            if ( this.limit_to_size >= meta_data.data.size_in_bytes ) return true;

            let nice_kb_size = this.limit_to_size / 1024;

            this.$rc.alert(
                'Size Limit Exceeded',
                'Maximum file size allowed: ' + nice_kb_size + " KB."
            );
        },

        createMenuItems(index)
        {
            return [
                { 'text': 'Move Up', 'cmd': 'move_up', 'disabled': index === 0 },
                { 'text': 'Move Down', 'cmd': 'move_down', 'disabled': index === this.blob_meta_data.length-1 },
                { 'text': 'Change Label...', 'cmd': 'change_label', 'disabled': false },
                { 'text': 'Delete', 'cmd': 'delete', 'disabled': false },
            ];
        },

        onClickMenuItem(index,item)
        {
            if ( item.cmd === 'move_up' )
            {
                let tmp = this.blob_meta_data[index-1];
                this.blob_meta_data[index-1] = this.blob_meta_data[index];
                this.blob_meta_data[index] = tmp;
                this.$forceUpdate(); 
            }

            if ( item.cmd === 'move_down' )
            {
                let tmp = this.blob_meta_data[index];
                this.blob_meta_data[index] = this.blob_meta_data[index+1];
                this.blob_meta_data[index+1] = tmp;
                this.$forceUpdate(); 
            }

            if ( item.cmd === 'delete' )
            {
                this.blob_meta_data.splice(index,1);
                this.$forceUpdate(); 
                this.validate();
            }

            if ( item.cmd === 'change_label' )
            {
                let new_label = window.prompt('Enter the new label',this.blob_meta_data[index].getLabel());

                if ( new_label == null )
                    return;
                
                this.$rc.patchBlob(this.blob_meta_data[index], false, new_label, this.afterPatch)
            }
        },

        validate()
        {
            if ( this.blob_meta_data.length == 0 )
            {
                // If VCard defined but no blobs, still valid (e.g. prepopulated from a Saved Message)
                this.valid = (null != this.vcard_id);
                return;
            }

            for ( let i = 0; i < this.blob_meta_data.length; i++ )
            {
                if ( !this.blob_meta_data[i].isProcessingComplete() )
                {
                    this.valid = false;
                    return;
                }
            }

            this.valid = true;
        },
        
        onOk()
        {
            let attachment_confirmation_settings = this.$rc.$state.profile.organization_account.features.attachment_confirmation_settings;

            // prompt users for external or internal attachments based on settings
            if ( (this.externally_visible && attachment_confirmation_settings.confirm_before_sending_externally)
                || (!this.externally_visible && attachment_confirmation_settings.confirm_before_sending_internally))
            {
                this.promptUserForConfirmation(attachment_confirmation_settings);
                return;
            }

            this.processBlobData();
        },

        processBlobData()
        {
            this.dialog = false;
            let blob_ids = [];
            for ( let i = 0; i < this.blob_meta_data.length; i++ )
                blob_ids.push(this.blob_meta_data[i].getBlobId());


            if ( this.show_with_message )
            {
                let with_message = this.with_message;

                if ( with_message == null )
                    with_message = '';

                with_message = with_message.trim();

                this.$emit('ok', {
                    'blob_ids' : blob_ids,
                    'with_message' : with_message,
                    'vcard_id': this.vcard_id,
                });
            }
            else
            {
                this.$emit('ok', blob_ids);
            }
        },

        promptUserForConfirmation(attachment_confirmation_settings)
        {
            let title = attachment_confirmation_settings.confirmation_title;
            let message = attachment_confirmation_settings.confirmation_message;
            let required_response = attachment_confirmation_settings.required_response;

            if (required_response && required_response.length > 0)
            {
                this.$rc.confirmWithResponse(
                    title,
                    message,
                    required_response,
                    [
                        {'text': 'Cancel', 'value': 'cancel'},
                        {'text': 'Confirm', 'value': 'confirm', 'disable_until_valid' : true },
                    ],

                    (response) => {
                        if (response == 'confirm') {
                            this.processBlobData();
                        } else {
                            return;
                        }
                    }
                );
            }
            else
            {
                this.$rc.confirm(
                    title,
                    message,
                    [
                        {'text': 'Cancel', 'value': 'cancel'},
                        {'text': 'Confirm', 'value': 'confirm'},
                    ],

                    (response) => {
                        if (response == 'confirm') {
                            this.processBlobData();
                        } else {
                            return;
                        }
                    }
                );
            }
        },

        getSendImagesAsLinks()
        {
            return this.options.includes('send-images-as-links');
        },

        addDropFile(e)
        {
            this.pending_upload_count = 0;

            for ( let i = 0; i < e.dataTransfer.files.length; i++ )
            {
                this.show_upload = true;
                this.spinner_indeterminate = true;
                this.pending_upload_count++;

                if ( e.dataTransfer.files[i].size > 1024*1024*1024 )
                    alert("Unable to upload file.  File size is limited to 1 GB");
                else
                    this.$rc.uploadBlob(e.dataTransfer.files[i], this.purpose, this.process_media, this.afterUpload, this.onUploadProgress, this.organization_id);
            }
        },

        uploadFiles(files)
        {
            for ( let i = 0; i < files.length; i++ )
            {
                this.show_upload = true;
                this.spinner_indeterminate = true;
                this.pending_upload_count++;

                if ( files[i].size > 1024*1024*1024 )
                    alert("Unable to upload file.  File size is limited to 1 GB");
                else
                    this.$rc.uploadBlob(files[i],this.purpose, this.process_media, this.afterUpload, this.onUploadProgress, this.organization_id);
            }
        },

        onUploadProgress(progress)
        {
            this.spinner_indeterminate = false;
            this.spinner_value = progress.loaded / progress.total * 100;
        },

        afterUpload(meta_data)
        {
            this.blob_meta_data.push(meta_data);
            this.validate();

            this.pending_upload_count--;
            if ( this.pending_upload_count < 0 ) this.pending_upload_count = 0;

            if ( this.pending_upload_count == 0 ) 
            {
                this.show_upload = false;
            }
        },

        afterPatch(meta_data)
        {
            for ( let i = 0; i < this.blob_meta_data.length; i++ )
            {
                if ( this.blob_meta_data[i].getBlobId() === meta_data.getBlobId() )
                {
                    this.blob_meta_data[i] = meta_data;
                    this.$forceUpdate();
                    return;
                }
            }
        },

        showFileOpenDialog()
        {
            let input = this.$refs['input-file-upload'];
            input.value = null;
            input.click();
        },

        onClickAddContactCard()
        {
            this.$refs['choose-vcard-dialog'].showDialog({
                'organization_id': this.$rc.$state.getOrganizationId(),
                'for_organization_owned_endpoint' : this.for_endpoint,
            });
        },

        onFileControlChanged(e)
        {
            this.uploadFiles(e.target.files); 
        },

        getBlobSrcURL(meta_data)
        {
            return this.$rc.getBlobEndpoint(meta_data);
        },

        getLabel(item)
        {
            if ( item.isProcessingPending() && item.isQuicktimeMovie() )
            {
                return item.getLabel() + ' (converting to mp4)';
            }

            return item.getLabel()
        },

        showHelpSendImagesAsLinks()
        {
            let message = '';
            message += 'You can text an image as either a multi-media message (MMS) or a hyperlink.<br/><br/>';
            message += 'Images sent via MMS are limited in size to one megabyte.  This means that any image you sent via MMS must be downsized by RedChirp to send properly.<br/><br/>';
            message += 'When you choose to send an image as a hyperlink, the image is sent full size and will typically arrive significantly faster.  However, a user must click a link to view or download the image.<br/><br/>';
            message += 'If someone is having trouble receiving your image messages, or they are arriving slowly, try sending them as a hyperlink';

            this.$rc.alert('Send images as links', message);
        },

        loadRecentFilesByEmployee()
        {
            this.$rc.rest({
                'spinner': false,
                'endpoint': 'GET: /api/v1/media-assets/profile-send-media',
            
                'params' : {
                    },
            
                'on_success': (data) => {
                        this.recent_files = data.recent_files;
                        this.show_outshinery = data.show_outshinery;

                        if ( this.accept.includes("csv") )
                            this.show_outshinery = false;
                    },
            
                'on_error': 'Unable to get send media profile',
            });
        },

        onClickMediaAssetPicker(created_by)
        {
            this.$refs['media-asset-picker'].showDialog();
        },
    },

    computed: {

        no_files()
        {
            return this.blob_meta_data.length == 0;
        }
    },
}
</script>

<style lang="scss" scoped>

</style>